import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class UnionBenefitsBus extends BaseBus
{
    constructor(busObj: UnionBenefitsBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.unionBenefitLookupId;
    }

    unionBenefitLookupId: any;
    unionId: any;
    jobRoleId: any;
    applyType: number;
    hoursWorked: number;
    hoursPaid: number;
    perGross: number;
    payPerCheck: number;
    payCode: string;
    benefitDesc: string;
    union: string;
    jobRole: string;
    applyTypeDesc: String;
    maxHourlyUsed: number;
    otUnionRate: number;
    dtUnionRate: number;
    action: String;
    updatedBy: String;
    updatedOn: Date
}
